export type ToastVariant = 'overtake' | 'best';

export interface ToastMessage {
  primary: string;       // 첫째 줄 (크게)
  secondary?: string;    // 둘째 줄 (작게)
}

export class Toast {
  private readonly el: HTMLElement;

  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'toast';
    parent.appendChild(this.el);
  }

  show(message: ToastMessage, variant: ToastVariant = 'overtake'): void {
    const primary = `<span class="toast-primary">${escapeHtml(message.primary)}</span>`;
    const secondary = message.secondary
      ? `<span class="toast-secondary">${escapeHtml(message.secondary)}</span>`
      : '';
    this.el.innerHTML = primary + secondary;
    this.el.classList.remove('toast-visible', 'toast-overtake', 'toast-best');
    this.el.classList.add(`toast-${variant}`);
    // 애니메이션 재시작을 위해 강제 reflow.
    void this.el.offsetWidth;
    this.el.classList.add('toast-visible');
  }

  hide(): void {
    this.el.classList.remove('toast-visible');
  }
}

function escapeHtml(text: string): string {
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };
  return text.replace(/[&<>"']/g, (ch) => map[ch] ?? ch);
}
